import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { LOGIN } from "../common/constants/routes.constants";
import { useAuthContext } from "../context/AuthContext";

interface IProtectedRoute {
  redirectPath?: string;
  children: ReactNode;
}
export const ProtectedRoute: FC<IProtectedRoute> = ({
  redirectPath = LOGIN,
  children,
}: IProtectedRoute) => {
  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }
  return <>{children}</>;
};
